import React, { useState } from 'react';
import { useCachedMedia } from '../hooks/use-cached-media';
import { cn } from '../lib/utils';

interface CachedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    src: string;
}

export function CachedImage({ src, className, onLoad, onError, ...props }: CachedImageProps) {
    const cachedSrc = useCachedMedia(src) || src;
    // Fade in once the picture has arrived instead of popping in. Stays shown
    // when the source switches to the cached copy (no second fade).
    const [shown, setShown] = useState(false);

    return (
        <img
            src={cachedSrc}
            className={cn(className, "transition-opacity duration-300", shown ? "opacity-100" : "opacity-0")}
            onLoad={(e) => {
                setShown(true);
                onLoad?.(e);
            }}
            onError={(e) => {
                setShown(true);
                onError?.(e);
            }}
            {...props}
        />
    );
}
